import axios from "./axiosInstance";

/**
 * API para módulo de reportes
 * Proporciona métodos para obtener reportes y filtros disponibles
 */
class ReportesApi {
  /**
   * Obtiene un reporte específico con filtros aplicados
   * @param {string} tipoReporte - Tipo de reporte: "REPORTES_POR_ASESOR", "REPORTES_POR_SEDE", "REPORTES_POR_TIPO", "REPORTES_TIEMPOS_GESTION"
   * @param {object} filtros - Objeto con filtros opcionales
   * @param {string} filtros.fecha_desde - Fecha desde (YYYY-MM-DD)
   * @param {string} filtros.fecha_hasta - Fecha hasta (YYYY-MM-DD)
   * @param {number} filtros.asesor_id - ID del asesor
   * @param {number} filtros.sede_id - ID de la sede
   * @param {number} filtros.estado_id - ID del estado
   * @param {number} filtros.tipo_proceso_id - ID del tipo de proceso
   * @param {boolean} filtros.validado - Filtrar por validado
   * @param {boolean} filtros.admitido - Filtrar por admitido
   * @returns {Promise} Respuesta con datos del reporte
   */
  static obtenerReporte = async (tipoReporte, filtros = {}) => {
    return axios.get(`/procesos/estadisticas/${tipoReporte}/`, {
      params: filtros,
    });
  };

  /**
   * Obtiene las opciones disponibles para los filtros
   * @returns {Promise} Respuesta con asesores, sedes, estados, tipos de proceso y rangos de fechas
   */
  static obtenerFiltrosDisponibles = async () => {
    return axios.get("/procesos/estadisticas/filtros-reportes/");
  };

  /**
   * Obtiene reporte por asesor
   * @param {object} filtros - Filtros opcionales
   * @returns {Promise} Respuesta con datos agrupados por asesor
   */
  static obtenerReportePorAsesor = async (filtros = {}) => {
    return ReportesApi.obtenerReporte("REPORTES_POR_ASESOR", filtros);
  };

  /**
   * Obtiene reporte por sede
   * @param {object} filtros - Filtros opcionales
   * @returns {Promise} Respuesta con datos agrupados por sede
   */
  static obtenerReportePorSede = async (filtros = {}) => {
    return ReportesApi.obtenerReporte("REPORTES_POR_SEDE", filtros);
  };

  /**
   * Obtiene reporte por tipo de proceso
   * @param {object} filtros - Filtros opcionales
   * @returns {Promise} Respuesta con datos agrupados por tipo
   */
  static obtenerReportePorTipo = async (filtros = {}) => {
    return ReportesApi.obtenerReporte("REPORTES_POR_TIPO", filtros);
  };

  /**
   * Obtiene reporte de tiempos de gestión
   * @param {object} filtros - Filtros opcionales
   * @returns {Promise} Respuesta con promedios de días por estado
   */
  static obtenerReporteTiemposGestion = async (filtros = {}) => {
    return ReportesApi.obtenerReporte("REPORTES_TIEMPOS_GESTION", filtros);
  };
}

export default ReportesApi;
